/**
 * Phóng sinh (Thanh Tịnh Pháp — Phóng sinh) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const LifeReleaseListPage = lazy(() =>
  import("@/features/life-liberation").then((mod) => ({ default: mod.LifeReleaseListPage })),
);
const SpeciesSummaryPage = lazy(() =>
  import("@/features/life-liberation").then((mod) => ({ default: mod.SpeciesSummaryPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const lifeReleaseListRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phong-sinh/ho-so",
  component: withSuspense(LifeReleaseListPage),
});
const speciesSummaryRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phong-sinh/thong-ke",
  component: withSuspense(SpeciesSummaryPage),
});

export const phongSinhRoutes = [
  lifeReleaseListRoute,
  speciesSummaryRoute,
];
